import { cacheKeys } from "@constants/cache-keys";
import { isScreenshotMode } from "@constants/common";
import { isMockedData } from "@constants/demo";
import { mockedLeaderboard } from "@constants/mocked-data";
import useAppConfigIds from "@hooks/useAppConfigIds";
import useClerkUser from "@hooks/useClerkUser";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { type PeriodType, fetchLeaderboardItems } from "../api";
import { filterChips } from "../components/Leaderboard/constants";

const useLeaderboard = () => {
	const [selectedChip, setSelectedChip] = useState<PeriodType>(
		filterChips[0].id as PeriodType,
	);

	const { projectId, organizationId } = useAppConfigIds();
	const { userPublicMetadataId } = useClerkUser();

	const { data: leaderboardResponse, isLoading: fetchingLeaderboard } =
		useQuery({
			queryKey: [cacheKeys.leaderboard, selectedChip],
			queryFn: () =>
				isScreenshotMode
					? mockedLeaderboard[selectedChip as PeriodType]
					: fetchLeaderboardItems({
							periodType: selectedChip,
							projectId,
							organizationId,
							userId: userPublicMetadataId,
						}),
			enabled:
				isMockedData ||
				(!!projectId && !!organizationId && !!userPublicMetadataId),
		});

	const finalLeaderboards = leaderboardResponse;

	const leaderboardPodiumData = finalLeaderboards
		?.slice(0, 3)
		.map((item, index) => ({
			...item,
			rank: index + 1,
		}));

	const reorderedPodiumData = leaderboardPodiumData?.length
		? [
				leaderboardPodiumData[1],
				leaderboardPodiumData[0],
				leaderboardPodiumData[2],
			]
		: [];
	return {
		leaderboards: finalLeaderboards,
		fetchingLeaderboard,
		podiumData: reorderedPodiumData,
		selectedChip,
		handleSelectChip: (chip: PeriodType) => setSelectedChip(chip),
	};
};

export default useLeaderboard;
